import SocialMediaListItem from './SocialMediaListItem'

export default SocialMediaListItem
